import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Operation } from '../models/subscription';
import { AppService } from '@app/app.service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService as appConfig } from '@app/app.config';
import { OperationMapperService } from '../mappers/operation-mapper';
import { OperationData } from '../interfaces/data/operation-data.interface';

@Injectable({
    providedIn: 'root',
})
export class SaveDataService {

    private appData = inject(AppService);
    private appConfig = inject(appConfig);
    private http = inject(HttpClient);
    private operationMapperService = inject(OperationMapperService);

    savedData: Subject<any> = new Subject<any>();

    constructor() {
        this.savedData.subscribe((value) => {
            this.appData.data.userData = value;
        });
    }

    saveDataLocal(dataPage: any, pageStep: string) {
        console.log('1', dataPage);

        switch (pageStep) {
            case 'privacy-settings':
                this.appData.data.userData.privacySettings = dataPage;
                break;

            case 'co-holder':
                this.appData.data.userData.coHolder = dataPage;
                break;

            case 'identification':
                this.appData.data.userData.identification = dataPage;
                break;

            case 'personal-data-info':
                this.appData.data.userData.personalDataInfo = dataPage;
                break;

            case 'personal-data-birth':
                this.appData.data.userData.personalDataBirth = dataPage;
                break;

            case 'co-operator':
                this.appData.data.userData.coOperator = dataPage;
                break;

            case 'additional-data-first':
                this.appData.data.userData.additionalDataFirst = dataPage;
                break;

            case 'additional-data-second':
                this.appData.data.userData.additionalDataSecond = dataPage;
                break;

            case 'additional-data-loan':
                this.appData.data.userData.additionalDataLoan = dataPage;
                break;

            case 'house-type':
                this.appData.data.userData.houseType = dataPage;
                break;

            case 'house-address':
                this.appData.data.userData.houseAddress = dataPage;
                break;

            case 'bank-details':
                dataPage.iban = dataPage.bankDetails.iban?.replace(/\s+/g, '');
                this.appData.data.userData.bankDetails = dataPage;
                break;

            case 'contact-data-info':
                this.appData.data.userData.contactDataInfo = dataPage;
                break;

            case 'contract-type':
                this.appData.data.userData.contractType = dataPage;
                break;

            case 'authenticationData':
                this.appData.data.userData.authenticationData = dataPage;
                break;

            case 'documentation-data':
                this.appData.data.userData.documentation = dataPage;
                break;

            case 'working-situation':
                this.appData.data.userData.workingSituation = dataPage;
                break;

        }

        console.log('2', this.appData.data);

        this.savedData.next(this.appData.data.userData);
    }

    saveOperation (): Observable<OperationData> {
        console.log('AppData', this.appData);

        //const operacion : Operation =  MockOperation.createMockOperation();
        const operacion : Operation = this.operationMapperService.transform(this.appData.data) ;

        const OPERATION_URL: string = this.appConfig.apiBffUrl + '/api/mobility/operation';
        //const OPERATION_URL: string = 'http://localhost:8080/api/mobility/operation';

        console.log("url", OPERATION_URL);
        console.log("operation ", operacion);
        return this.http.post<OperationData>(OPERATION_URL, operacion);
    }

}
